import api from '@/utils/api';

const { baseApi, customerAll } = window.GlobalConfig;

// 查询客户库
export const queryCustomerSimple = params => {
    return api.post(`${baseApi}/customer`, {
        ...params
    });
};

// 客户列表
export const queryCustomerPage = data => {
    return api.post(`${baseApi}/customer/getCustomerListPage`, data);
};

// 客户列表
export const queryCustomerAllList = data => {
    return api.post(`${baseApi}/customer/getCustomerListPage`, { pageNum: 1, pageSize: customerAll });
};

// 新建客户
export const addCustomer = data => {
    return api.post(`${baseApi}/customer/addCustomer`, data);
};

// 查询客户信息
export const queryCustomerSimpleInfo = params => {
    return api.get(`${baseApi}/customer/getCustomerDetailByCustomerId/${params.customerId}`);
};

// 删除客户
export const deleteCustomer = ({ customerId }) => {
    return api.get(`${baseApi}/customer/removeByCustomerId/${customerId}`);
};

// 管理员编辑客户
export const updateCustomer = data => {
    return api.post(`${baseApi}/customer/updateCustomerAll`, data);
};

// 普通编辑客户
export const updateCommonCustomer = data => {
    return api.post(`${baseApi}/customer/updateCustomerCommon`, data);
};

// 标记劣质客户
export const markCustomerLower = data => {
    return api.post(`${baseApi}/mark/lower`, data);
};

// 客户合同
export const QueryCustomerContracts = ({ customerId }) => {
    return api.get(`/cooperation/getCustomerCooperationByCustomer/${customerId}`);
};

//
export const QueryCustomerVisit = data => {
    return api.post(`/visitPlan/getVisitPlanByCustomerIdPage`, data);
};

// ============= 开发中管理 ===========

// 开发转化
export const translateCustomerDev = data => {
    return api.post(`${baseApi}/customerDevelop/convertCustomer2Develop`, data);
};

// 开发申请转化
export const translateApplyCustomerDev = data => {
    return api.post(`${baseApi}/customerDevelop/applyCustomer2Develop`, data);
};

export const approvalCustomer = data => {
    return api.post(`${baseApi}/customerDevelop/approveCustomer2Develop`, data);
};

export const queryDevelopApprovalRecord = data => {
    return api.post(`${baseApi}/customerDevelop/getCustomerDevelopApprovePage`, data);
};

export const queryDevelopApproval = data => {
    return api.post(`${baseApi}/customerDevelop/getCustomerDevelopApprovingPage`, data);
};

export const queryApproveDetail = ({ developId }) => {
    return api.get(`${baseApi}/customerDevelop/getApproveInfoByDevelopId/${developId}`);
};

export const approvalDelay = data => {
    return api.post(`/customerDevelop/apply2Delay`, data);
};

// 开发管理分页
export const queryDevCustomerPage = data => {
    return api.post(`${baseApi}/customerDevelop/getCustomerDevelopPage`, data);
};

export const QueryDevelopInfo = ({ developId }) => {
    return api.get(`/customerDevelop/getApproveInfoByDevelopId/${developId}`);
};

export const DevelopFail = data => {
    return api.post(`/customerDevelop/update2Fail`, data);
};

export const updateDevCustomer = data => {
    return api.post(`${baseApi}/customerDevelop/updateCustomerDevelop`, data);
};

export const queryDevCustomerInfo = ({ developId }) => {
    return api.get(`${baseApi}/customerDevelop/getCustomerDevelopById/${developId}`);
};

export const delayDevCustomer = data => {
    return api.post(`${baseApi}/customerDevelop/delayCustomerDevelop`, data);
};

export const developSuccess = data => {
    return api.post(`${baseApi}/customerDevelop/update2Success`, data);
};

export const developFail = data => {
    return api.post(`${baseApi}/customerDevelop/delayCustomerDevelop`, data);
};

export const developStop = data => {
    return api.post(`${baseApi}/customerDevelop/delayCustomerDevelop`, data);
};

// 签约信息

export const querySignedList = data => {
    return api.post(`${baseApi}/cooperation/getCustomerCooperationPage`, data);
};

export const SaveSigned = data => {
    return api.post(`${baseApi}/cooperation/addCustomerCooperation`, data);
};
export const UpdateSigned = data => {
    return api.post(`${baseApi}/cooperation/updateCustomerCooperation`, data);
};

export const UpdateMark = data => {
    return api.post(`${baseApi}/cooperation/updateCustomerCooperationRenew`, data);
};

// ============= 关键人 ===============

export const queryKeyManList = ({ customerId }) => {
    return api.get(`${baseApi}/keyman/getKeymanListByCustomerId/${customerId}`);
};

export const addKeyMan = data => {
    return api.post(`${baseApi}/keyman/addCustomerKeyman`, data);
};

export const updateKeyMan = data => {
    return api.post(`${baseApi}/keyman/updateCustomerKeyman`, data);
};

export const deleteKeyMan = ({ keymanId }) => {
    return api.get(`${baseApi}/keyman/deleteCustomerKeyman/${keymanId}`);
};

// ============ 竞争对手 ===============

export const QueryCustomerCompetitorList = ({ customerId }) => {
    return api.post(`${baseApi}/customerCompetitor/getCustomerCompetitorRelByCustomerId/${customerId}`);
};

export const AddCustomerCompetitor = data => {
    return api.post(`${baseApi}/customerCompetitor/addCustomerCompetitorRel`, data);
};

export const DeleteCustomerCompetitor = ({ id }) => {
    return api.post(`${baseApi}/customerCompetitor/deleteCustomerCompetitorRel/${id}`);
};

export const UpdateCustomerCompetior = data => {
    return api.post(`${baseApi}/customerCompetitor/updateCustomerCompetitorRel`, data);
};

export const GetCompetitorInfo = ({ competitorId }) => {
    return api.post(`${baseApi}`, data);
};

// 添加科室
export const AddCustomerDepartment = data => {
    return api.post(`${baseApi}/customerDepartment/addCustomerDepartment`, data);
};

export const QueryDepartmentByCustomerId = data => {
    return api.get(`${baseApi}/customerDepartment/getByCustomerId/${data.customerId}`);
};

export const UpdateCustomerDepartment = data => {
    return api.post(`${baseApi}/customerDepartment/updateCustomerDepartment`, data);
};

export const DeleteCustomerDepartment = ({ departmentId }) => {
    return api.get(`${baseApi}/customerDepartment/removeCustomerDepartment/${departmentId}`);
};

export const QueryCustomerDoctor = data => {
    return api.post(`${baseApi}/employee/getCustomerEmployeePage`, data);
};

export const SaveCustomerDoctor = data => {
    return api.post(`${baseApi}/employee/addCustomerEmployee`, data);
};

export const DeleteCustomerDoctor = ({ employeeId }) => {
    return api.delete(`${baseApi}/employee/removeCustomerEmployee/${employeeId}`);
};

export const UpdateCustomerDoctor = data => {
    return api.post(`${baseApi}/employee/updateCustomerEmployee`, data);
};

export const QueryDoctorInfo = employeeId => {
    return api.get(`${baseApi}/employee/getVoByEmployeeId/${employeeId}`);
};

export const QueryLetterPage = data => {
    return api.post(`${baseApi}/customerCreditArchive/getCustomerCreditArchiveExtPage`, data);
};

// 客户联系人

export const QueryCustomerContacts = data => {
    return api.post(`${baseApi}/employee/getCustomerEmployeePage`, data);
};

// 客户分布情况

export const QueryCustChart = data => {
    return api.post(``, data);
};

export const UpdateAllFlag = data => {
    return api.post(`/customer/updateCustomerOpportunityFlagBatch`, data);
};

//信息修改情况
export const QueryChangeLog = data => {
    return api.post(`/fieldChangeLog/getVoGroupByInfoId`, data);
};
